import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import { getTrustSignalDisplay } from './trustSignal.utils';
import { container, trustSignalSegment, trustSignalSeparator, trustSignalText } from './trustSignal.styles';

export const TrustSignal = () => {
  const listing = useSelector((state: RootReduxState) => state.currentListingDetails?.currentListing);

  // `ListingDetails.history` resolves to the DOM `History` global due to a
  // missing import in listingDetails.type.ts; narrow to the runtime shape here.
  const history = (
    listing as unknown as {
      history?: { activated?: { date?: number; ago?: string }; lastUpdated?: { date?: number; ago?: string } };
    }
  )?.history;

  const { listedText, listedIso, updatedText, updatedIso, showListed, showUpdated } = getTrustSignalDisplay(history);

  if (!showListed && !showUpdated) {
    return null;
  }

  return (
    <div className={container}>
      <p data-testid="text-trust-signal" className={trustSignalText}>
        {showUpdated && (
          <span className={trustSignalSegment}>
            {updatedIso ? <time dateTime={updatedIso}>{updatedText}</time> : <span>{updatedText}</span>}
          </span>
        )}
        {showListed && (
          <span className={trustSignalSegment}>
            {showUpdated && (
              <span className={trustSignalSeparator} aria-hidden="true">
                ·
              </span>
            )}
            {listedIso ? <time dateTime={listedIso}>{listedText}</time> : <span>{listedText}</span>}
          </span>
        )}
      </p>
    </div>
  );
};
